import { Grid, Typography } from '@mui/material';

import { FCheckboxGroup } from '../../../../../../components/baseV2';
import ChecklistColumn from './ChecklistColumn';
import {
  CHECKLIST_GRID_SX,
  CHECKLIST_GROUP_SUBTITLE_SX,
  CHECKLIST_GROUP_SX,
} from '../styles';
import { getChecklistItemsForColumn } from '../utils';

import type { ChecklistColumnsProps } from '../types';

export default function ChecklistColumns({
  errorMessage,
  footer,
  hasError = false,
  isEditable,
  items,
  onChange,
  subtitle,
  title,
  useNewUi,
}: ChecklistColumnsProps) {
  if (useNewUi) {
    return (
      <FCheckboxGroup
        label={title ?? ''}
        required
        error={hasError}
        helperText={hasError ? errorMessage : undefined}
        fullWidth
        sx={CHECKLIST_GROUP_SX}
        disabled={!isEditable}
      >
        {subtitle ? <Typography sx={CHECKLIST_GROUP_SUBTITLE_SX}>{subtitle}</Typography> : null}
        <Grid container sx={CHECKLIST_GRID_SX}>
          <ChecklistColumn
            items={getChecklistItemsForColumn(items, 1)}
            isEditable={isEditable}
            useNewUi={useNewUi}
            onChange={onChange}
            showDivider={false}
            offset={false}
          />
          <ChecklistColumn
            items={getChecklistItemsForColumn(items, 2)}
            isEditable={isEditable}
            useNewUi={useNewUi}
            onChange={onChange}
            showDivider={false}
            offset
          />
          <ChecklistColumn
            items={getChecklistItemsForColumn(items, 3)}
            isEditable={isEditable}
            useNewUi={useNewUi}
            onChange={onChange}
            showDivider={false}
            offset
          />
        </Grid>
        {footer}
      </FCheckboxGroup>
    );
  }

  return (
    <Grid container sx={CHECKLIST_GRID_SX}>
      <ChecklistColumn
        items={getChecklistItemsForColumn(items, 1)}
        isEditable={isEditable}
        useNewUi={useNewUi}
        onChange={onChange}
        showDivider
        offset={false}
      />
      <ChecklistColumn
        items={getChecklistItemsForColumn(items, 2)}
        isEditable={isEditable}
        useNewUi={useNewUi}
        onChange={onChange}
        showDivider
        offset
      />
      <ChecklistColumn
        items={getChecklistItemsForColumn(items, 3)}
        isEditable={isEditable}
        useNewUi={useNewUi}
        onChange={onChange}
        showDivider={false}
        offset
        footer={useNewUi ? footer : null}
      />
      {useNewUi ? null : footer}
    </Grid>
  );
}
